export const ProductionPlanFooter = () => (
  <div className="box-border flex h-15 shrink-0 items-center justify-center border-t border-border-primary bg-surface-secondary px-4" />
);
